import $ from 'jquery';
import 'waypoints/lib/jquery.waypoints.min';

const parallax = $('.parallax');
let scrollPosition = 0;

// handle parallax effect on background element.
function doParallax(position, element) {
  const offset = element.offset().top;
  const bottom = offset + element.outerHeight(true);

  if (position >= bottom) return;

  const speed = 0.5;
  const parallax = (position - offset) * speed;
  const translateY = parallax.toFixed(2);

  element.css({ transform: `translate3d(0, ${translateY}px, 0)` });
}

// only add event listener if background is present and we are not in mobile view
if (parallax && document.body.offsetWidth > 1200) {
  const parallaxImage = $('.parallax__image > img');
  window.addEventListener('scroll', function(e) {
    scrollPosition = $(this).scrollTop();
    // only call parallax function if we have reached the element
    parallax.waypoint(
      direction => {
        if (direction === 'down') {
          doParallax(scrollPosition, parallaxImage);
        }
      },
      {
        offset: '100%',
      }
    );
  });
}
